import { render, staticRenderFns } from "./PersonalDetailsRegistration.vue?vue&type=template&id=78b9b584&scoped=true&"
import script from "./PersonalDetailsRegistration.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9b584",
  null
  
)

export default component.exports